import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  Inject,
  ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Gallery, GalleryItem, ImageSize, ImageItem } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatSort, Sort } from '@angular/material/sort';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { splitAtColon } from '@angular/compiler/src/util';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { Bank, BANKS } from './state-data';

import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import { UserProfileComponent } from 'src/app/modals/user-profile/user-profile.component';

/**
 * @title Table with pagination
 */
/**
 * @title Table with sorting
 */
export interface BankGroup {
  name: string;
  banks: Bank[];
}
export interface Element {
  postedDate: string;
  type: string;
  farmerName: string;
  location: string;
  quantity: string;
  minPrice: string;
  maxPrice: string;
  availableDate: string;
  status: string;
  tradeInterest: string;
  geoLocation: string;
}

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit {
  statedata;
  filtershow = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = [
    'postedDate',
    'type',
    'farmerName',
    'location',
    'geoLocation',
    'quantity',
    'maxPrice',
    'minPrice',
    'availableDate',
    'status',
    'tradeInterest',
  ];
  dataSource = new MatTableDataSource<Element>([]);

  getAverageData: any = [];
  averageData;
  userdata;
  productDataList = [];
  productData;

  selectedSorting: string;
  selectFilterData1;

  form = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  selectFilterData;
  searchData = '';
  filterbyText = '';
  filterbylanguage = '';

  public matChipArray = [];
  exportcsvdata = false;
  removable = true;
  //sorting table
  dataSourcelist;
  @ViewChild(MatSort) sort: MatSort;
  customDate = false;

  productTypeList = ['Coconut', 'Copra', 'Tender Coconut'];
  varietyList = {
    Coconut: [
      'Big (>550 gms)',
      'Medium (400-550 gms)',
      'Small (<400 gms)',
      'Coconut With Husk',
      'Coconut without husk',
    ],
    Copra: [
      'Edible Copra',
      'Low Moisture Copra <5%',
      'Sada Copra',
      'Crude Copra',
      'Ball Copra',
    ],
    'Tender Coconut': ['Green', 'Orange'],
  };

  dateRangeMaxDate = new Date();

  newsform: FormGroup;
  reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  regexStr = '^[0-9]*$';
  response;
  submitted = false;
  selected;

  totalData;
  avgData;
  ranges: any = {
    // 'Today': [moment(), moment()],
    // 'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    '1 Week': [moment().subtract(6, 'days'), moment()],
    '1 Month': [moment().subtract(29, 'days'), moment()],
    '3 Months': [moment().subtract(59, 'days'), moment()],
    '6 Months': [moment().subtract(179, 'days'), moment()],
    '1 Year': [moment().subtract(364, 'days'), moment()],
  };

  statusList = [
    { value: 0, viewValue: 'Available' },
    { value: 1, viewValue: 'Sold Out' },
    { value: 2, viewValue: 'Expired' },
  ];
  // maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
  // minDate = new Date();
  maxDate;
  minDate;

  /** list of banks */
  protected banks: Bank[] = BANKS;

  /** total number of available entries */
  public allBanksSize = BANKS.length;

  /** control for the selected bank for multi-selection */
  public bankMultiCtrl: FormControl = new FormControl();

  public districtMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public bankMultiFilterCtrl: FormControl = new FormControl();

  public districtMultiFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  public filteredBanksMulti: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(
    1
  );

  public filteredDistrictMulti: ReplaySubject<Bank[]> = new ReplaySubject<
    Bank[]
  >(1);

  /** local copy of filtered banks to help set the toggle all checkbox state */
  protected filteredBanksCache: Bank[] = [];

  protected filteredDistrictCache = [];
  isIndeterminateDistrict = false;
  isCheckedDistrict = false;
  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;
  @ViewChild('multiSelectDistrict', { static: true })
  multiSelectDistrict: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective: DaterangepickerDirective;
  dialogRef: any;
  constructor(
    private router: Router,
    public toastr: ToastrService,
    private fb: FormBuilder,
    public gallery: Gallery,
    private spinner: NgxSpinnerService,
    public lightbox: Lightbox,
    public _userService: UserManagementService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    // this.newsform = this.fb.group({
    //   newsId: ['', [Validators.required]],
    //   newsTitle: ['', [Validators.required]],
    //   newsSource: ['', [Validators.required]],
    //   attachlink: ['', [Validators.pattern(this.reg)]],
    //   languages: [],
    //   remark: ['', [Validators.required]],
    //   date: [new Date()]
    // });

    // this.averageNews();
    this.adminProductsData();
    this.getHeaderData();
    // load the initial bank list
    this.filteredBanksMulti.next(this.banks.slice());

    this.filteredDistrictMulti.next(this.selectDistrict.slice());

    // listen for search field value changes
    this.bankMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanksMulti();
        this.setToggleAllCheckboxState();
      });

    this.districtMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterDistrictMulti();
        this.districtSetToggleAllCheckboxState();
      });

    this.districtMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.districtSetToggleAllCheckboxState();
      });
    // listen for multi select field value changes
    this.bankMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.setToggleAllCheckboxState();
      });
  }

  openDatepicker() {
    this.pickerDirective.open();
  }

  // onDateRangeChanged(){
  // }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  suche() {
    setTimeout(() => {
      (document.querySelectorAll('#search1 div input')[1] as any).placeholder =
        'Search State';
    }, 5);
  }

  notFound() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll('#search1>div')[1] as any).innerText =
          'not found';
      }, 10);
    }
  }

  notFoundDistrict() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll('#search1>div')[1] as any).innerText =
          'not found';
      }, 10);
    }
  }
  sucheDistrict() {
    setTimeout(() => {
      (document.querySelectorAll('#search1 div input')[1] as any).placeholder =
        'Search District';
    }, 5);
  }
  /**
   * Sets the initial value after the filteredBanks are loaded initially
   */
  protected setInitialValue() {
    this.filteredBanksMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelect.compareWith = (a: Bank, b: Bank) =>
          a && b && a.id === b.id;
      });
  }

  protected districtSetInitialValue() {
    this.filteredDistrictMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelectDistrict.compareWith = (a: Bank, b: Bank) =>
          a && b && a.id === b.id;
      });
  }

  protected filterBanksMulti() {
    if (!this.banks) {
      return;
    }
    // get the search keyword
    let search = this.bankMultiFilterCtrl.value;
    if (!search) {
      this.filteredBanksCache = this.banks.slice();
      this.filteredBanksMulti.next(this.filteredBanksCache);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredBanksCache = this.banks.filter(
      (bank: any) => bank.stateName.toLowerCase().indexOf(search) > -1
    );
    this.filteredBanksMulti.next(this.filteredBanksCache);
  }

  protected filterDistrictMulti() {
    if (!this.eligbleDistricts()) {
      return;
    }
    // get the search keyword
    let search = this.districtMultiFilterCtrl.value;
    if (!search) {
      this.filteredDistrictCache = this.eligbleDistricts().slice();
      this.filteredDistrictMulti.next(this.filteredDistrictCache);
      this.selectDistrict = this.filteredDistrictCache;
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredDistrictCache = this.eligbleDistricts().filter(
      (item: any) => item.toLowerCase().indexOf(search) > -1
    );
    this.filteredDistrictMulti.next(this.filteredDistrictCache);
    this.selectDistrict = this.filteredDistrictCache;
  }

  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.bankMultiCtrl && this.bankMultiCtrl.value) {
      this.filteredBanksCache.forEach((el) => {
        if (this.bankMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredBanksCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredBanksCache.length;
    }
  }

  protected districtSetToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.districtMultiCtrl && this.districtMultiCtrl.value) {
      this.filteredDistrictCache.forEach((el) => {
        if (this.districtMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateDistrict =
        filteredLength > 0 &&
        filteredLength < this.filteredDistrictCache.length;
      this.isCheckedDistrict =
        filteredLength > 0 &&
        filteredLength === this.filteredDistrictCache.length;
    }
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredBanksMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.bankMultiCtrl.patchValue(val);
        } else {
          this.bankMultiCtrl.patchValue([]);
        }
      });
  }

  toggleSelectAlldistrict(selectAllValue: boolean) {
    this.filteredDistrictMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.districtMultiCtrl.patchValue(this.eligbleDistricts());
        } else {
          this.districtMultiCtrl.patchValue([]);
        }
      });
  }

  selectDistrict = [];

  filterMyOptions(items) {
    this.selectDistrict = [];
    if (this.bankMultiCtrl.value.length === 0) {
    } else {
      this.bankMultiCtrl.value.forEach((element) => {
        this.selectDistrict = this.selectDistrict.concat(element.districtName);
      });
    }
  }

  eligbleDistricts() {
    let dist = [];
    if (this.bankMultiCtrl.value.length === 0) {
    } else {
      this.bankMultiCtrl.value.forEach((element) => {
        dist = dist.concat(element.districtName);
      });
    }
    return dist;
  }

  getHeaderData() {
    this._userService.getAdminProductHeader().subscribe((data) => {
      this.totalData = data;
      this.avgData = this.totalData.result.data;
    });
  }

  adminProductsData() {
    this.spinner.show();
    var postdata = {
      pageNumber: 0,
      search: '',
      coconutType: '',
      verity: '',
      cultivation: '',
      fromDate: '',
      toDate: '',
      minPrice: 0,
      maxPrice: 0,
      minQuantity: 0,
      maxQuantity: 0,
      state: '',
      district: '',
      pageSize: 10,
    };

    this._userService.GetAdminProducts(postdata).subscribe((data) => {
      this.productData = data;
      this.paginationProperty = this.productData.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;
      this.totalPages = this.paginationProperty.totalPages;
      this.dataSource = new MatTableDataSource<Element>(
        this.productData.result.data.list
      );

      this.dataSource.sort = this.sort;
      this.spinner.hide();
    });
  }

  averageNews() {
    this._userService.getAverageNews().subscribe((data) => {
      this.averageData = data;
      this.getAverageData = this.averageData.result.data;
    });
  }

  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }

  opendropdown = false;
  openDrop() {
    this.opendropdown = true;
  }

  startdata;
  enddata;
  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      this.enddata = dates.endDate
        ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
      this.startdata = dates.startDate
        ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
    }
  }

  /*=========================================== apply filter ======================================================================== */
  filterbylanguageName = '';
  languageName = '';
  filterbyformdate = '';
  filterbytodayte = '';
  districtdata = [];
  filterbysource = '';
  source: '';
  subProductName: '';
  filterbysubProductName: '';
  sharedate;
  filterbysharedate = '';
  filterbystate = [];
  filterbydistrict = [];
  productTypeName = '';
  filterbyproduct = '';
  filterbystatus: '';
  statusdata: '';
  filterbyvariety = '';
  varietyName = '';
  filterbyquantity = '';
  filterbyprice = '';
  formdate = this.datePipe.transform(
    this.form.controls.start.value,
    'yyyy/MM/dd hh:mm:ss'
  );
  todayte = this.datePipe.transform(
    this.form.controls.end.value,
    'yyyy/MM/dd hh:mm:ss'
  );
  applyfilter(checkEmpty) {
    this.matChipArray = [];
    let totalState = [];
    if (this.statedata) {
      this.statedata.forEach((ele: any) => {
        totalState.push(ele.stateName);
      });
    }

    if (
      checkEmpty &&
      !this.productTypeName &&
      !this.varietyName &&
      !this.searchData &&
      !this.statusdata &&
      !this.quantity &&
      !this.priceValue &&
      totalState.length == 0 &&
      this.districtdata.length == 0 &&
      !this.sharedate.endDate &&
      !this.sharedate.startDate
    ) {
      alert('Please provide input first');
    } else {
      this.filterbystate = totalState;
      this.filterbydistrict = this.districtdata;
      this.filterbyproduct = this.productTypeName;
      this.filterbyvariety = this.varietyName;
      this.exportcsvdata = true;
      this.filterbyText = this.searchData;
      this.filterbysource = this.source;
      this.filterbysharedate = this.sharedate;
      this.filterbyformdate = this.enddata;
      this.filterbytodayte = this.startdata;
      this.filterbystatus = this.statusdata;
      this.filterbyquantity = this.quantity;
      this.filterbyprice = this.priceValue;

      let indexproduct = this.matChipArray.findIndex(
        (x) => x.tag === 'productTypeName'
      );
      let indexvariety = this.matChipArray.findIndex(
        (x) => x.tag === 'varietyName'
      );
      let indexstatus = this.matChipArray.findIndex(
        (x) => x.tag === 'statusdata'
      );
      let indexsharedate = this.matChipArray.findIndex(
        (x) => x.tag === 'sharedate'
      );
      let indexsharequantity = this.matChipArray.findIndex(
        (x) => x.tag === 'quantity'
      );
      let indexprice = this.matChipArray.findIndex(
        (x) => x.tag === 'priceValue'
      );
      let indexformdate = this.matChipArray.findIndex(
        (x) => x.tag === 'formdate'
      );
      let indextodayte = this.matChipArray.findIndex(
        (x) => x.tag === 'todayte'
      );

      if (totalState != null) {
        totalState.forEach((ele) => {
          this.matChipArray.push({
            name: 'State' + ':' + ele,
            tag: 'state',
            flag: true,
          });
        });
      }

      if (this.districtdata != null) {
        this.districtdata.forEach((ele) => {
          this.matChipArray.push({
            name: 'District' + ':' + ele,
            tag: 'district',
            flag: true,
          });
        });
      }

      if (this.sharedate && this.startdata && this.enddata) {
        if (indexsharedate > -1) {
          this.matChipArray[indexsharedate].name =
            'Shared date' +
            ':' +
            (this.sharedate['startDate']
              ? this.sharedate['startDate'].format('DD/MM/YYYY')
              : '') +
            ' to ' +
            (this.sharedate['endDate']
              ? this.sharedate['endDate'].format('DD/MM/YYYY')
              : '');
        } else {
          this.matChipArray.push({
            name:
              'Shared date' +
              ':' +
              (this.sharedate['startDate']
                ? this.sharedate['startDate'].format('DD/MM/YYYY')
                : '') +
              ' to ' +
              (this.sharedate['endDate']
                ? this.sharedate['endDate'].format('DD/MM/YYYY')
                : ''),
            tag: 'sharedate',
            flag: true,
          });
        }
      }

      if (this.productTypeName != '') {
        if (indexproduct > -1) {
          this.matChipArray[indexproduct].name =
            'Product' + ':' + this.productTypeName;
        } else {
          if (this.productTypeName != '' && this.productTypeName != undefined) {
            this.matChipArray.push({
              name: 'Product' + ':' + this.productTypeName,
              tag: 'productTypeName',
              flag: true,
            });
          }
        }
      }

      if (this.varietyName != '') {
        if (indexvariety > -1) {
          this.matChipArray[indexvariety].name =
            'Variety' + ':' + this.varietyName;
        } else {
          if (this.varietyName != '' && this.varietyName != undefined) {
            this.matChipArray.push({
              name: 'Variety' + ':' + this.varietyName,
              tag: 'varietyName',
              flag: true,
            });
          }
        }
      }

      if (this.statusdata != '') {
        if (indexstatus > -1) {
          this.matChipArray[indexstatus].name =
            'Product' + ':' + this.statusdata;
        } else {
          if (this.statusdata != '' && this.statusdata != undefined) {
            this.matChipArray.push({
              name: 'Status' + ':' + this.statusdata,
              tag: 'statusdata',
              flag: true,
            });
          }
        }
      }

      if (this.quantity != '') {
        if (indexsharequantity > -1) {
          this.matChipArray[indexsharequantity].name =
            'Quantity' + ':' + this.quantity;
        } else {
          if (this.quantity != '' && this.quantity != undefined) {
            this.matChipArray.push({
              name: 'Quantity' + ':' + this.quantity,
              tag: 'quantity',
              flag: true,
            });
          }
        }
      }

      if (this.priceValue != '') {
        if (indexprice > -1) {
          this.matChipArray[indexprice].name = 'Price' + ':' + this.priceValue;
        } else {
          if (this.priceValue != '' && this.priceValue != undefined) {
            this.matChipArray.push({
              name: 'Price' + ':' + this.priceValue,
              tag: 'priceValue',
              flag: true,
            });
          }
        }
      }

      var postdata = {
        fromDate: this.startdata,
        toDate: this.enddata,
        search: this.filterbyText,
        coconutType: this.productTypeName,
        verity: this.varietyName,
        status: this.statusdata,
        cultivation: '',
        minPrice: this.minValue != '' ? this.minValue : 0,
        maxPrice: this.maxValue != '' ? this.maxValue : 0,
        minQuantity: this.minquantity != '' ? this.minquantity : 0,
        maxQuantity: this.maxquantity != '' ? this.maxquantity : 0,
        state: this.filterbystate.join(','),
        district: this.districtdata.join(','),
        pageNumber: 0,
        pageSize: 10,
      };

      this._userService.GetAdminProducts(postdata).subscribe((data) => {
        this.productData = data;
        this.paginationProperty = this.productData.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.totalPages = this.paginationProperty.totalPages;
        this.dataSource = new MatTableDataSource<Element>(
          this.productData.result.data.list
        );

        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }

  remove(index, tag): void {
    if (tag === 'state') {
      let removedState: any = this.matChipArray.splice(index, 1);
      // this.totalState = "";
      let val = JSON.parse(JSON.stringify(this.statedata));
      let i = val.findIndex(
        (x) => removedState[0].name === 'State:' + x.stateName
      );
      val.splice(i, 1);
      // this.bankMultiCtrl.setValue([]);
      this.bankMultiCtrl.setValue(val);
      // this.bankMultiCtrl.setValue(this.statedata);
    }
    if (tag === 'district') {
      let removedDistrict: any = this.matChipArray.splice(index, 1);
      let val = JSON.parse(JSON.stringify(this.districtdata));
      let i = val.findIndex(
        (x) => removedDistrict[0].name === 'District:' + x.districtName
      );
      val.splice(i, 1);
      this.districtMultiCtrl.setValue(val);
    }

    if (tag === 'productTypeName') {
      this.matChipArray.splice(index, 1);
      this.productTypeName = '';
    }

    if (tag === 'varietyName') {
      this.matChipArray.splice(index, 1);
      this.varietyName = '';
    }

    if (tag === 'statusdata') {
      this.matChipArray.splice(index, 1);
      this.statusdata = '';
    }

    if (tag === 'sharedate') {
      this.matChipArray.splice(index, 1);
      this.sharedate = undefined;
    }
    if (tag === 'quantity') {
      this.matChipArray.splice(index, 1);
      this.quantity = '';
      this.minquantity = 0;
      this.maxquantity = 0;
    }
    if (tag === 'priceValue') {
      this.matChipArray.splice(index, 1);
      this.priceValue = '';
      this.minValue = 0;
      this.maxValue = 0;
    }

    setTimeout(() => {
      this.applyfilter(false);
    }, 500);
  }

  changeFn(event: any) {
    if (event.isTrusted == true) {
      this.applyfilter(false);
    }
  }
  /*......................Pagination.................*/
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;
  length: number;
  previousPageIndex;
  pagechangeevent;
  searchText = '';
  searchDate = '';

  public getServerData(event?: PageEvent) {
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;
    if (this.exportcsvdata == true) {
      var postdata = {
        fromDate: this.startdata,
        toDate: this.enddata,
        search: this.filterbyText,
        coconutType: this.productTypeName,
        verity: this.varietyName,
        cultivation: '',
        minPrice: this.minValue,
        maxPrice: this.maxValue,
        minQuantity: this.minquantity,
        maxQuantity: this.maxquantity,
        state: this.filterbystate.join(','),
        district: this.districtdata.join(','),
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };

      this._userService.GetAdminProducts(postdata).subscribe((data) => {
        this.userdata = data;
        this.productData = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.productData);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    } else {
      postdata = {
        fromDate: '',
        toDate: '',
        search: '',
        coconutType: '',
        verity: '',
        cultivation: '',
        minPrice: 0,
        maxPrice: 0,
        minQuantity: 0,
        maxQuantity: 0,
        state: '',
        district: '',
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };

      this._userService.GetAdminProducts(postdata).subscribe((data) => {
        this.userdata = data;
        this.productData = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.productData);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  quantity;
  minquantity;
  maxquantity;
  open(): void {
    let quantityValue = '';
    const dialogRef = this.dialog.open(addValue, {});
    dialogRef.afterClosed().subscribe((result) => {
      this.quantity = result;
      quantityValue = this.quantity.split('-');
      this.minquantity = quantityValue[0];
      this.maxquantity = quantityValue[1];
    });
  }

  priceValue;
  minValue;
  maxValue;
  openPriceDialog(): void {
    let rangeValue = '';
    const dialogRef = this.dialog.open(priceValue, {});

    dialogRef.afterClosed().subscribe((result) => {
      this.priceValue = result;
      rangeValue = this.priceValue.split('-');
      this.minValue = rangeValue[0];
      this.maxValue = rangeValue[1];
    });
  }

  onSubmit() {
    this.dialogRef.close();
  }
  /*====================================================View Profile ================================================================ */
  city: string;
  name: string;
  food_from_modal: string;

  openDialog(data): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
    const dialogRef = this.dialog.open(UserProfileComponent, {
      width: '60%',
      height: '71%',
      data: { name: data.farmerId },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  /* open model pop up */
  /*====================================================View Profile ================================================================ */

  dialogresult;
  mainresult;
  apidata;
  openDialogexport(): void {
    const dialogRef = this.dialog.open(productExportData, {
      width: '60%',
      height: '75%',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;
      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);

          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyfilter(false);

              var postdata = {
                fromDate: this.startdata,
                toDate: this.enddata,
                search: this.filterbyText,
                coconutType: this.productTypeName,
                verity: this.varietyName,
                status: this.statusdata,
                cultivation: '',
                minPrice: this.minValue,
                maxPrice: this.maxValue,
                minQuantity: this.minquantity,
                maxQuantity: this.maxquantity,
                state: this.filterbystate.join(','),
                district: this.districtdata.join(','),
                pageNumber: this.pageIndex,
                reportKeyList: Result,
              };

              this._userService
                .getAdminProductsReport(postdata)
                .subscribe((data) => {
                  this.apidata = data;
                  const blob = new Blob([this.apidata], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  var anchor = document.createElement('a');
                  anchor.download = 'productList.xlsx';
                  anchor.href = url;
                  anchor.click();
                });
            } else {
              postdata = {
                pageNumber: 0,
                search: '',
                coconutType: '',
                status: '',
                verity: '',
                cultivation: '',
                fromDate: '',
                toDate: '',
                minPrice: 0,
                maxPrice: 0,
                minQuantity: 0,
                maxQuantity: 0,
                state: '',
                district: '',
                reportKeyList: Result,
              };
              this._userService
                .getAdminProductsReport(postdata)
                .subscribe((data) => {
                  this.apidata = data;
                  const blob = new Blob([this.apidata], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  // window.open(url);
                  var anchor = document.createElement('a');
                  anchor.download = 'productList.xlsx';
                  anchor.href = url;
                  anchor.click();
                });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one column to generate report!');
          this.openDialogexport();
        }
      }
      //================================REPORT GENERATE==========================================//
    });
  }
}

@Component({
  selector: 'add-value',
  templateUrl: 'add-value.html',
})
export class addValue {
  formdelet: FormGroup;
  response;
  min = null;
  max = null;
  constructor(
    public dialogRef: MatDialogRef<addValue>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.formdelet = this.fb.group({
      min: ['', [Validators.required]],
      max: ['', [Validators.required]],
    });
  }
  onSubmit() {
    if (this.min && this.max) {
      this.dialogRef.close(this.min + '-' + this.max);
    } else {
      alert('please enter valid number');
    }
  }
}

@Component({
  selector: 'add-value',
  templateUrl: 'add-value.html',
})
export class priceValue {
  formdelet: FormGroup;
  response;
  min = null;
  max = null;
  constructor(
    public dialogRef: MatDialogRef<priceValue>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.formdelet = this.fb.group({
      min: ['', [Validators.required]],
      max: ['', [Validators.required]],
    });
  }
  onSubmit() {
    if (this.min && this.max) {
      this.dialogRef.close(this.min + '-' + this.max);
    } else {
      alert('please enter valid number');
    }
  }
}
// New Export Data functinality //
@Component({
  selector: 'product-export-data',
  templateUrl: 'product-export-data.html',
})
export class productExportData {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<productExportData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, viewValue: 'Product ID', value: 'productID', isSelected: false },
      { id: 2, viewValue: 'Type', value: 'Type', isSelected: false },
      { id: 3, viewValue: 'Variety', value: 'variety', isSelected: false },
      {
        id: 4,
        viewValue: 'Cultivation',
        value: 'cultivation',
        isSelected: false,
      },
      { id: 5, viewValue: 'Quantity', value: 'Quantity', isSelected: false },
      { id: 6, viewValue: 'Min Price', value: 'MinPrice', isSelected: false },
      { id: 7, viewValue: 'Max Price', value: 'MaxPrice', isSelected: false },
      { id: 8, viewValue: 'languages', value: 'languages', isSelected: false },
      {
        id: 9,
        viewValue: 'Geo Location',
        value: 'GeoLocation',
        isSelected: false,
      },
      { id: 10, viewValue: 'Location', value: 'Location', isSelected: false },
      {
        id: 11,
        viewValue: 'Farmer Name',
        value: 'FarmerName',
        isSelected: false,
      },
      { id: 12, viewValue: 'Taluk', value: 'taluk', isSelected: false },
      { id: 13, viewValue: 'District', value: 'district', isSelected: false },
      { id: 14, viewValue: 'State', value: 'state', isSelected: false },
      {
        id: 15,
        viewValue: 'Posted On',
        value: 'PostedDate',
        isSelected: false,
      },
      {
        id: 16,
        viewValue: 'Available Till',
        value: 'AvailableDate',
        isSelected: false,
      },
      { id: 17, viewValue: 'Status', value: 'Status', isSelected: false },
      {
        id: 18,
        viewValue: 'Trade Interest',
        value: 'TradeInterest',
        isSelected: false,
      },
      //{ id: 6, value: 'Updated By', isSelected: false }
    ];
    this.getCheckedItemList();
  }

  ngOnInit(): void {}

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}
